import { render, staticRenderFns } from "./phanqua.vue?vue&type=template&id=6c2320a0&scoped=true&"
import script from "./phanqua.vue?vue&type=script&lang=js&"
export * from "./phanqua.vue?vue&type=script&lang=js&"
import style0 from "./phanqua.vue?vue&type=style&index=0&id=6c2320a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../usr/lib/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2320a0",
  null
  
)

export default component.exports